import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Spring/MultiplicationAndDivision/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivision',
  field: 'Number',
  weeks: [3, 7],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/1RecogniseEqualGroups" */ './1RecogniseEqualGroups'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/2MakeEqualGroups" */ './2MakeEqualGroups'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/3AddEqualGroups" */ './3AddEqualGroups'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/4IntroduceMultiplicationSymbol" */ './4IntroduceMultiplicationSymbol'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/5MultiplicationSentences" */ './5MultiplicationSentences'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/6UseArrays" */ './6UseArrays'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/7MakeEqualGroupsGrouping" */ './7MakeEqualGroupsGrouping'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/8MakeEqualGroupsSharing" */ './8MakeEqualGroupsSharing'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/9The2TimesTable" */ './9The2TimesTable'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/10DivideBy2" */ './10DivideBy2'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/11DoublingAndHalving" */ './11DoublingAndHalving'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/12OddAndEvenNumbers" */ './12OddAndEvenNumbers'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/13The10TimesTable" */ './13The10TimesTable'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/14DivideBy10" */ './14DivideBy10'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/15The5TimesTable" */ './15The5TimesTable'
        )
    }),
    // Step 16
    newSmallStepContent({
      ...BlockModel.smallSteps[15],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/16DivideBy5" */ './16DivideBy5'
        )
    }),
    // Step 17
    newSmallStepContent({
      ...BlockModel.smallSteps[16],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/MultiplicationAndDivision/17The5And10TimesTables" */ './17The5And10TimesTables'
        )
    })
  ]
});
export default Block;
